// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectReportMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { FieldsFactory } from "../Factory/FieldsFactory.js";
import { BusinessRejectMessage } from "../Messages/BusinessRejectMessage.js";
import { MessageProcessorBase } from "./MessageProcessorBase.ts"

export let BusinessRejectMessageProcessor = function ()
{
    MessageProcessorBase.call(this);
}
BusinessRejectMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype);

// TODO. WIP. Refactor. Business reject should be treated differently.
// Here's workaround for now: creating of report message from business reject message.
BusinessRejectMessageProcessor.prototype.decode = function (fieldSet)
{
    let rejectMsg = new BusinessRejectMessage(fieldSet)

    let reportMessage = new DirectReportMessage()
    reportMessage.Name = 'general.trading.refused'
    let comment = rejectMsg.getComment();
    reportMessage.BusinessRejectCode = fieldSet.GetValue(FieldsFactory.FIELD_ERROR_CODE);
    let tmp_comment = BusinessRejectMessageProcessor.bussinessRejectErrorDictionary[reportMessage.BusinessRejectCode]
    if (tmp_comment)
        comment = tmp_comment;
    reportMessage.Data = [['Error', comment]]
    reportMessage.reject = true;
    return [reportMessage]
}

BusinessRejectMessageProcessor.bussinessRejectErrorDictionary =
{
    417: "Resources.Property.Opening market orders are forbidden",
    103: "reports.Order TIF is forbidden by trade session",
    371: "Session has expired. Please login.",
    432: "Product request cannot be processed.",
    433: "The total limit of alerts has been reached.",
    434: "Alert cannot be created due to wrong node.",
    435: "Bid/Ask prices are not available for the instrument.",
    436: "Product subscription failure: Unable to subscribe because there are no active accounts for charging on product.",
    437: "Product subscription failure: Not enough balance to pay fee.",
    446: "Product is no longer relevant for use",
    453: "BusinessRejectMessage.453"
    // "Alert has not been created, the maximum number of alerts for the user has been reached."  //ожидаю код id:99971
}